import { render, staticRenderFns } from "./1+1_2.vue?vue&type=template&id=2af566d0&scoped=true"
import script from "./1+1_2.vue?vue&type=script&lang=js"
export * from "./1+1_2.vue?vue&type=script&lang=js"
import style0 from "./1+1_2.vue?vue&type=style&index=0&id=2af566d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af566d0",
  null
  
)

export default component.exports